import React from 'react'
// import PropTypes from 'prop-types'
import styled from 'styled-components';
import { Checkbox } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment'
// import ExcelIcon from '../../../../assets/icons/ic_excel.svg';
// import SendIcon from '../../../../assets/icons/ic_send-email.svg';


const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #FFFFFF;
  padding: 1em;
  border-bottom: 1px solid #efefef;
  @media screen and (max-width: 500px) {
    width: max-content
  }
`
const DateTxt = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  margin-bottom: .2em;
  text-transform: capitalize;
`
const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 500px) {
    margin: ${({marginMobile}) => marginMobile};
  }
`
const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media screen and (max-width: 500px) {
    margin: ${({marginMobile}) => marginMobile};
  }
`
const LocationTxt = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #7C3F88;
`
const StoreIcon = styled.img`
  height: 12px;
  width: 14px;
  margin-right: .5em;
`
const DetailTxt = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #6A6A6A;
`
const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({color='#5E388A'}) => color};
  width: 40px;
  height: 40px;
  border-radius: 160px;
  margin-right: 1em;
  cursor: pointer;
`
const SendIcon = styled.img`
  margin-top: 2.5px;
  height: 19px;
  width: 20px;
`
const ExcelIcon = styled.img`
  height: 17.5px;
  width: 20px;
`
const TruckIcon = styled.img`
  height: 16px;
  width: 15px;
  margin-right: .5em;
`
const PapperCheckIc = styled.img`
  height: 13.5px;
  width: 13.5px;
  margin-right: .5em;
`
const ChevronRight = styled.img`
  height: 32px;
  width: 32px;
  cursor: pointer;
`
const PurpleCheckbox = withStyles({
  root: {
    color: '#CFD4D8',
    '&$checked': {
      color: '#5E388A',
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />);

const ItemResend = ({ row, rowIndex, onClickCheckBox, checked, registerDate, company, storeName, purchaseOrdersCount, onClickDetail, onClickSend, onClickExport }) => {
  return (
    <Container>
      <RowDiv marginMobile="0 1.5em 0 0">
        <PurpleCheckbox
          checked={checked}
          onClick={() => onClickCheckBox(row, rowIndex)}
        />
        <ColumnDiv>
          <DateTxt>
            {moment(registerDate).format("ddd [  ]DD MMM YYYY [-] hh:mm A") ||
              "Mié, 20 may. 2020 - 10:34 a.m."}
          </DateTxt>
          <RowDiv>
            <StoreIcon src={require("../../../../assets/icons/ic_store.svg")} />
            <LocationTxt>{storeName}</LocationTxt>
          </RowDiv>
        </ColumnDiv>
      </RowDiv>
      <ColumnDiv marginMobile="0 1.5em 0 0">
        <RowDiv>
          <TruckIcon src={require("../../../../assets/icons/ic_truck.svg")} />
          <DetailTxt>{company}</DetailTxt>
        </RowDiv>
        <RowDiv>
          <PapperCheckIc
            src={require("../../../../assets/icons/ic_papper-check.svg")}
          />
          <DetailTxt>
            <span style={{ fontWeight: 500 }}>{purchaseOrdersCount}</span>{" "}
            pedidos escaneados
          </DetailTxt>
        </RowDiv>
      </ColumnDiv>
      <ColumnDiv marginMobile="0 1.5em 0 0">
        <div style={{ minWidth: "283px" }}>
          <DetailTxt>{row.stage === "RT" ? row.code : row.id}</DetailTxt>
        </div>
      </ColumnDiv>
      <RowDiv>
        <IconContainer onClick={() => onClickSend(row.id)} color="#F15B5B">
          <SendIcon
            src={require("../../../../assets/icons/ic_send-email.svg")}
          />
        </IconContainer>
        <IconContainer onClick={() => onClickExport(row.id)}>
          <ExcelIcon src={require("../../../../assets/icons/ic_excel.svg")} />
        </IconContainer>
        <ChevronRight
          onClick={onClickDetail}
          src={require("../../../../assets/icons/ic_chevron-right_2.svg")}
        />
      </RowDiv>
    </Container>
  );
}

export default ItemResend
